<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'reports.rateTrends.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <app-report-filter-bar [includeAllUsers]="includeAllUsers" (filtersChange)="onFiltersChange($event)" />

      <form [formGroup]="bucketGroupForm" class="bucket-group-form no-print">
        <formly-form [form]="bucketGroupForm" [fields]="bucketGroupFields" [model]="bucketGroupModel" />
      </form>

      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg no-print">
          <app-spinner />
        </div>
      } @else if (points().length === 0) {
        <p class="empty-state" data-testid="rate-trends-empty">{{ 'reports.rateTrends.empty' | translate }}</p>
      } @else {
        <table class="report-table" data-testid="rate-trends-table">
          <thead>
            <tr>
              <th>{{ 'reports.rateTrends.date' | translate }}</th>
              <th>{{ 'reports.rateTrends.group' | translate }}</th>
              <th>{{ 'reports.dailyActivity.doors' | translate }}</th>
              <th>{{ 'reports.dailyActivity.contacts' | translate }}</th>
              <th>{{ 'reports.dailyActivity.contactRate' | translate }}</th>
              <th>{{ 'reports.dailyActivity.leads' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (point of points(); track point.bucketLabel + point.groupKey) {
              <tr>
                <td>{{ point.bucketLabel }}</td>
                <td>{{ point.groupLabel }}</td>
                <td>{{ point.doors }}</td>
                <td>{{ point.contacts }}</td>
                <td>{{ (point.contactRate * 100).toFixed(1) }}%</td>
                <td>{{ point.leads }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </app-card-content>
    @if (canExport) {
      <app-card-actions class="no-print">
        <app-button variant="outlined" (click)="exportCsv()" data-testid="export-csv-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportCsv' | translate }}
        </app-button>
        <app-button variant="outlined" (click)="exportXlsx()" data-testid="export-xlsx-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportXlsx' | translate }}
        </app-button>
      </app-card-actions>
    }
  </app-card>
</div>
